/**
* This file originated from:
* File: app/views/layouts/bonz.html
* In commit: 78c68c2a59ae1b30aac5b88d7b90659f4aca5fb0
* For ticket: GRINS-1511
*/

/* from: app/views/layouts/partials/shared/coreFdRequireScripts.html */
import '@grins/fd-modules/splits/require-core';

/* from:  app/views/layouts/partials/oneRing/oneRingScripts.html */
import '@grins/fd-modules/splits/onering-global';

/* from: javascripts/bundles/bonz/legacy-libraries.js */
import 'fd-url-manager/client/fd-url-manager.ts';
import '@fd-assets/micromodal/microModal.js';


/* from: javascripts/bundles/transpiled/bonz/bonz.app.js */
import '@grins/fd-modules/bonz/layout/bonz.app';

